
import { useParams } from 'react-router-dom'

import { withStyles } from '@material-ui/core/styles'
import styles from './navigateTabStyles'


import ListTabs from '../../LeftHand/NavigateTabs/ListTabs'
import Dashboard from '../../RightHand/DashboardPage/Dashboard'
import Department from '../../RightHand/Department/Department'
import Roles from '../../RightHand/Roles/Roles'
import Users from '../../RightHand/Users/Users'
import InCompleteKYC from '../../RightHand/InCompleteKYC/InCompleteKYC'
import Campaign from '../../RightHand/Campaign/Campaign'
import AgentsStats from '../../RightHand/Monitoring/AgentsStats'
import Whatsapp from '../../RightHand/Whatsapp/whatsapp'
import Uploads from '../../RightHand/Uploads/Uploads' //dev-trupti on 09-12-2024
import Franchise from '../../RightHand/Franchise/Franchise' //dev-trupti on 18-12-2024
import FranchiseDashboard from '../../RightHand/FranchiseDashboard/FranchiseDashboard' // Srini 07-01-25
import LearningCentre from '../../RightHand/LearningCentre/LearningCentre'
import BlogsPage from '../../RightHand/Blogs/BlogsPage'
import Engagement from '../../RightHand/Engagement/Engagement'
import WealthVault from '../../RightHand/WealthVault/WealthVault'
import Faqs from '../../RightHand/FaqsAdmin/FaqsAdmin' // srini 09-05-25
import Research from '../../RightHand/Research/Research'
import Ticket from '../../RightHand/Ticket/Ticket'
import ServiceCase from '../../RightHand/ServiceCase/ServiceCase'
import Operation from "../../RightHand/Operations/Operations"
const NavigateTabs = ({ classes, location }) => {
    
    const { activePage } = useParams()


    return (
        <div className={classes.background}>
            <>
                <ListTabs />
            </>
            <>
                {/* { activePage === 'dashboard' && <Dashboard />}
              
                */}
                {activePage === 'department' && <Department />}
                {activePage === 'users' && <Users />}
                {activePage === 'roles' && <Roles />}
                { activePage === 'incomplete-kyc' && <InCompleteKYC />}
                {activePage === 'ticket' && <Ticket />}
                {activePage === 'servicecase' && <ServiceCase />}
                {activePage === 'franchise' && <Franchise />} 
                {activePage === "faqs" && <Faqs />}
                {activePage === "blogs" && <BlogsPage />}
                {activePage === "research" && <Research />}
                {activePage === "operations" && <Operation />}
                {/* Component rendering - 16/09/24 -Dev Srini */}
                {/* { activePage === 'social-campaign' && <Campaign />}
                { activePage === 'whatsapp' && <Whatsapp/>}
                { activePage === 'monitoring' && <AgentsStats />}
                { activePage === 'uploads' && <Uploads/>} 
               
                {/* // Srini 07-01-25 */}
                {/* { activePage === 'franchiseDashboard' && <FranchiseDashboard />} 
                {activePage ==='learningCentre'  && <LearningCentre/> }

               
                {activePage ==='engagement'  && <Engagement /> } */}
                
                {/* Wealth Valut */}
                {/* {activePage === "wealth_vault" && <WealthVault/>}
                  */}
            </>
        </div>
    )
}

export default withStyles(styles)(NavigateTabs)